import { useSelector } from "react-redux";
import store from "../../stores/store";
import FeaturesTable from "../controls/featuresTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useEffect } from "react";
import { formatSelectedFeatures, trans, key } from "../../lib/utils";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

function CSWlResults() {
  const results = useSelector((state) => store.getState().results);

  const cswResults = results.cswResults;

  const activeTab =
    results.resultsPanelActiveTab === "cswResults"
      ? "cswResults".concat(Object.keys(cswResults).length - 1)
      : results.resultsPanelActiveTab;

  const layers = useSelector((state) => store.getState().layers);

  const sources = useSelector((state) => store.getState().sources);

  useEffect(() => {
    window["recaclulatePerfectScrollbarHeight"]();
  }, []);

  return (
    <>
      <PerfectScrollbar style={{ height: "45px" }}>
        <ul className="nav nav-tabs navbar-expand small">
          {cswResults
            ? Object.keys(cswResults)?.map((results, resultsIndex) => {
                return (
                  <li
                    className="nav-item "
                    role="button"
                    onClick={() => {
                      window["recaclulatePerfectScrollbarHeight"]();
                    }}
                  >
                    <span
                      className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                        activeTab.startsWith("cswResults".concat(resultsIndex))
                          ? "active"
                          : ""
                      )}
                      onClick={() => {
                        store.dispatch({
                          type: "results/setActiveTab",
                          payload: "cswResults".concat(resultsIndex),
                        });
                      }}
                    >
                      <span className="color-black">
                        {trans("Search results").concat(" ", resultsIndex + 1)}
                      </span>
                      <i
                        className="fas fa-times ms-2 results-close-icon"
                        onClick={() => {
                          window["primaryModal"].setState({
                            show: true,
                            size: "default",
                            title: trans("Delete confirmation"),
                            body: (
                              <div className="p-2">
                                {trans("Are you sure you want to remove")}{" "}
                                <strong>
                                  '{"Search results ".concat(resultsIndex + 1)}'
                                </strong>{" "}
                                {trans("tab")}?
                              </div>
                            ),
                            footer: [
                              <button
                                className="btn btn-sm btn-link"
                                onClick={(e) => {
                                  window["primaryModal"].setState({
                                    show: false,
                                  });
                                }}
                              >
                                {trans("Cancel")}
                              </button>,
                              <button
                                className="btn btn-sm btn-danger text-white"
                                onClick={(e) => {
                                  store.dispatch({
                                    type: "results/cswResults/delete",
                                    payload: {
                                      id: results,
                                    },
                                  });
                                  window["primaryModal"].setState({
                                    show: false,
                                  });
                                }}
                              >
                                {trans("Delete")}
                              </button>,
                            ],
                          });
                        }}
                      ></i>
                    </span>
                  </li>
                );
              })
            : ""}
        </ul>
      </PerfectScrollbar>
      <div className="tab-content ">
        {cswResults
          ? Object.keys(cswResults)?.map((results, resultsIndex) => {
              return (
                <div
                  className={"tab-pane fade ".concat(
                    activeTab.startsWith("cswResults".concat(resultsIndex))
                      ? "show active"
                      : ""
                  )}
                  role="tabpanel"
                >
                  <PerfectScrollbar style={{ height: "45px" }}>
                    <ul className="nav nav-tabs navbar-expand small">
                      {cswResults[results]?.map((result, resultIndex) => {
                        return (
                          <li
                            className="nav-item "
                            role="button"
                            onClick={() => {
                              window["recaclulatePerfectScrollbarHeight"]();
                            }}
                          >
                            <span
                              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                                activeTab.startsWith(
                                  "cswResults".concat(
                                    resultsIndex,
                                    "-",
                                    resultIndex
                                  )
                                )
                                  ? "active"
                                  : ""
                              )}
                              onClick={() => {
                                store.dispatch({
                                  type: "results/setActiveTab",
                                  payload: "cswResults".concat(
                                    resultsIndex,
                                    "-",
                                    resultIndex
                                  ),
                                });
                              }}
                            >
                              <span className="color-black">
                                {sources[result.source]?.title?.concat(
                                  " ",
                                  resultIndex + 1,
                                  " (",
                                  result.data?.length,
                                  ")"
                                )}
                              </span>
                              <i
                                className="fas fa-times ms-2 results-close-icon"
                                onClick={() => {
                                  window["primaryModal"].setState({
                                    show: true,
                                    size: "default",
                                    title: trans("Delete confirmation"),
                                    body: (
                                      <div className="p-2">
                                        {trans(
                                          "Are you sure you want to remove"
                                        )}{" "}
                                        <strong>
                                          '
                                          {sources[
                                            result.source
                                          ]?.title?.concat(
                                            " ",
                                            resultIndex + 1
                                          )}
                                          '
                                        </strong>{" "}
                                        {trans("tab")}?
                                      </div>
                                    ),
                                    footer: [
                                      <button
                                        className="btn btn-sm btn-link"
                                        onClick={(e) => {
                                          window["primaryModal"].setState({
                                            show: false,
                                          });
                                        }}
                                      >
                                        {trans("Cancel")}
                                      </button>,
                                      <button
                                        className="btn btn-sm btn-danger text-white"
                                        onClick={(e) => {
                                          store.dispatch({
                                            type: "results/cswResults/results/delete",
                                            payload: {
                                              parentId: results,
                                              id: resultIndex,
                                            },
                                          });
                                          window["primaryModal"].setState({
                                            show: false,
                                          });
                                        }}
                                      >
                                        {trans("Delete")}
                                      </button>,
                                    ],
                                  });
                                }}
                              ></i>
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </PerfectScrollbar>
                  <div className="tab-content ">
                    {cswResults[results]?.map((result, resultIndex) => {
                      return (
                        <div
                          className={"tab-pane fade ".concat(
                            activeTab.startsWith(
                              "cswResults".concat(
                                resultsIndex,
                                "-",
                                resultIndex
                              )
                            )
                              ? "show active"
                              : ""
                          )}
                          role="tabpanel"
                        >
                          <div className="mb-1">
                            <button
                              className="btn btn-sm btn-link border"
                              onClick={() => {
                                store.dispatch({
                                  type: "csw/search/criteria/clone",
                                  payload: result.params.criteria,
                                });

                                store.dispatch({
                                  type: "app/leftPanelActiveTab",
                                  payload: "cswsearch",
                                });
                              }}
                            >
                              <i className="fas fa-pencil-alt me-2"></i>
                              {trans("Edit criteria")}
                            </button>
                          </div>
                          <PerfectScrollbar className="scrollbar-recaclulate">
                            <BootstrapTable
                              keyField="fileIdentifier"
                              key={key()}
                              data={result.data}
                              expandRow={{
                                renderer: (row) => {
                                  return row.abstract;
                                },
                                showExpandColumn: true,
                                onlyOneExpanding: true,
                                expandColumnRenderer: ({
                                  expanded,
                                  rowKey,
                                  expandable,
                                }) => {
                                  return !expanded ? (
                                    <i className="fas fa-plus"></i>
                                  ) : (
                                    <i className="fas fa-minus"></i>
                                  );
                                },
                              }}
                              columns={[
                                {
                                  dataField: "fileIdentifier",
                                  text: "",
                                  hidden: true,
                                },
                                {
                                  dataField: "legend",
                                  headerStyle: (colum, colIndex) => {
                                    return {
                                      width: "50px",
                                      textAlign: "center",
                                    };
                                  },
                                  formatter: function (cell, row) {
                                    return (
                                      <div className="text-center">
                                        <img
                                          src={window["appConfig"]()
                                            ["path"]()
                                            .concat("assets/images/", row.icon)}
                                          height="16"
                                        ></img>
                                      </div>
                                    );
                                  },
                                },
                                {
                                  dataField: "metadataInfo",
                                  headerStyle: (colum, colIndex) => {
                                    return {
                                      width: "22px",
                                      textAlign: "center",
                                    };
                                  },
                                  formatter: function (cell, row) {
                                    let url = window["appConfig"]()["api"](
                                      "metadataGetRecordsById.php?lang=el_gr&recordId=".concat(
                                        row.fileIdentifier,
                                        "&serviceUrl=",
                                        row.serverUrl
                                      )
                                    );

                                    return (
                                      <div
                                        className="text-center"
                                        role="button"
                                        onClick={() => {
                                          window["secondaryModal"].setState({
                                            title: "",
                                            size: "xl",
                                            height: "calc(100vh - 210px)",
                                            show: true,
                                            title: row.title,
                                            body: (
                                              <iframe
                                                src={url}
                                                width={"100%"}
                                                height={"99%"}
                                              ></iframe>
                                            ),
                                            footer: [
                                              <button
                                                className="btn btn-sm btn-link border"
                                                onClick={() => {
                                                  window[
                                                    "secondaryModal"
                                                  ].setState({
                                                    show: false,
                                                  });
                                                }}
                                              >
                                                {trans("Close")}
                                              </button>,
                                            ],
                                          });
                                        }}
                                      >
                                        <i className="fas fa-info-circle "></i>
                                      </div>
                                    );
                                  },
                                },
                                {
                                  dataField: "title",
                                  type: "text",
                                  text: trans("Title"),
                                  filter: textFilter(),
                                  sort: true,

                                  formatter: function (cell, row) {
                                    return (
                                      <span
                                        role="button"
                                        className="text-break"
                                      >
                                        {row.title}
                                      </span>
                                    );
                                  },
                                },
                              ]}
                              wrapperClasses="bg-white"
                              striped
                              hover
                              filter={filterFactory()}
                            />
                          </PerfectScrollbar>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          : ""}
      </div>
    </>
  );
}

export default CSWlResults;
